import SectionsDesktop from './sections.desktop';
import SectionsMobile from './sections.mobile';

export default {
  desktop: SectionsDesktop,
  mobile: SectionsMobile,
};
